import { render } from "./QuestionEditor.vue?vue&type=template&id=4ee4f5e2"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"
script.render = render

export default script